module.exports = __webpack_public_path__ + "img/notice-modal-ja-JP.976a7ba8.png";